import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Zap, ArrowRight, Clock } from 'lucide-react';
import ParticleBackground from '../components/ParticleBackground';

export default function TankSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(10);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center p-4">
      <ParticleBackground />
      
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-black/40 backdrop-blur-md border border-green-500/30 rounded-2xl p-8 max-w-md w-full text-center relative z-10"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
          className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <CheckCircle className="w-12 h-12 text-green-500" />
        </motion.div>

        <h1 className="text-3xl font-bold text-white mb-4 font-orbitron">
          Platba úspěšná!
        </h1>

        <p className="text-gray-300 mb-6 leading-relaxed">
          Vaše platba byla úspěšně zpracována. Brzy obdržíte přístupové údaje pro ovládání tanku na váš email.
        </p>

        <div className="bg-gray-800/50 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-center space-x-2 text-[#EE1C23] mb-2">
            <Zap className="w-5 h-5" />
            <span className="font-semibold">Ovládání tanku aktivováno</span>
          </div>
          <p className="text-gray-400 text-sm">
            Session ID: {sessionId?.slice(0, 20)}...
          </p>
        </div>

        <div className="space-y-3">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate('/')}
            className="w-full bg-gradient-to-r from-[#EE1C23] to-red-600 text-white py-3 rounded-lg font-semibold hover:from-red-600 hover:to-[#EE1C23] transition-all flex items-center justify-center space-x-2"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Zpět na hlavní stránku</span>
          </motion.button>

          <p className="text-gray-500 text-sm flex items-center justify-center space-x-1">
            <Clock className="w-4 h-4" />
            <span>Automatické přesměrování za {countdown}s</span>
          </p>
        </div>
      </motion.div>
    </div>
  );
}